import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'
import { transparentize } from 'polished'

const DOCUMENT_VIEWER_WIDTH = '35%'

export const ReviewEntryDetailPanel = styled.div`
  display: flex;
  gap: ${Spacing.S24};
  width: calc(100% - 36px);
  height: calc(100% - 32px);
  padding: ${Spacing.S24};
  border-radius: ${BorderRadius.R16};
  background-color: ${Color.White};
  box-shadow: -8px 2px 20px ${transparentize(0.84, Color.Black)};
  overflow: hidden;
`

export const DocumentViewerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  width: ${DOCUMENT_VIEWER_WIDTH};
  height: 100%;
  border: 1px solid ${Color.Grey150};
  border-radius: ${BorderRadius.R8};
  position: relative;
  background-color: ${Color.Grey100};
  overflow: hidden;
`

export const EntriesContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
  height: 100%;
`

export const ReviewEntryDetailContentArea = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: ${Spacing.S24};
  padding-top: ${Spacing.S24};
  padding-right: ${Spacing.S8};
  overflow: auto;
  scrollbar-gutter: stable;
`

export const EntryFormWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`

export const ValidateRow = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: flex-end;
  padding-top: ${Spacing.S16};
  padding-right: ${Spacing.S8};
  padding-bottom: ${Spacing.S4};
  overflow: hidden;
  scrollbar-gutter: stable;
`
